export const AGENT_DIAGNOSTICS_HEADER = 'x-mcpanel-agent-diagnostics';
export const DIAGNOSTIC_MAX_BYTES = 4096;
export const CONSOLE_OUTPUT_MAX_LENGTH = 4000;

/** Redact before truncating, so a secret crossing the limit never leaks a prefix. */
export function redactSecrets(text: string, secrets: Iterable<string>) {
  for (const secret of [...secrets].filter(Boolean).sort((a, b) => b.length - a.length))
    text = text.replaceAll(secret, '[REDACTED]');
  return text
    .replace(/(Bearer\s+)[^\s"']+/gi, '$1[REDACTED]')
    .replace(
      /((?:password|token|secret|code|totp_secret|newPassword)["']?\s*[:=]\s*)("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*')/gi,
      '$1"[REDACTED]"',
    )
    .replace(
      /((?:password|token|secret|code|totp_secret|newPassword)["']?\s*[:=]\s*["']?)[^\s,"'}]+/gi,
      '$1[REDACTED]',
    );
}

export function truncateUtf8(text: string, maxBytes = DIAGNOSTIC_MAX_BYTES) {
  let result = '';
  let bytes = 0;
  const encoder = new TextEncoder();
  for (const character of text) {
    bytes += encoder.encode(character).length;
    if (bytes > maxBytes) break;
    result += character;
  }
  return result;
}

/** Sliding window, rather than allowing a double burst at minute boundaries. */
export class DiagnosticLimiter {
  private times: number[] = [];
  constructor(private readonly now: () => number = Date.now) {}
  take() {
    const now = this.now();
    this.times = this.times.filter((at) => now - at < 60_000);
    if (this.times.length >= 20) return false;
    this.times.push(now);
    return true;
  }
}
